import { gql, useQuery } from '@apollo/client';

import { useSponsorPaywallModal_PostFragment } from './graphql-types/useSponsorPaywallModal_PostFragment';
import {
  useSponsorPaywallModal_RespondToPostPaywallQuery,
  useSponsorPaywallModal_RespondToPostPaywallQueryVariables,
} from './graphql-types/useSponsorPaywallModal_RespondToPostPaywallQuery';

const PAYWALL_QUERY = gql`
  query useSponsorPaywallModal_RespondToPostPaywallQuery(
    $input: SingleOrganizationInput!
  ) {
    organization(input: $input) {
      result {
        _id
        sponsorship {
          currentTier {
            shouldShowUpgradeCTA
            discussionPaywallText {
              title
              subtitle
            }
          }
        }
      }
    }
  }
`;

export const useSponsorPaywallModal = (
  post: useSponsorPaywallModal_PostFragment | null
): {
  headerText: string;
  bodyText: string;
  shouldShowUpgradeCTA?: boolean;
  organizationId: string;
} => {
  const organizationId = post?.organization?._id;

  const { data: paywallData } = useQuery<
    useSponsorPaywallModal_RespondToPostPaywallQuery,
    useSponsorPaywallModal_RespondToPostPaywallQueryVariables
  >(PAYWALL_QUERY, {
    variables: {
      input: {
        id: organizationId,
      },
    },
    skip: !organizationId,
  });
  const currentTier =
    paywallData?.organization?.result?.sponsorship?.currentTier;

  return {
    headerText: currentTier?.discussionPaywallText?.title || '',
    bodyText: currentTier?.discussionPaywallText?.subtitle || '',
    shouldShowUpgradeCTA: currentTier?.shouldShowUpgradeCTA,
    organizationId: '',
  };
};
useSponsorPaywallModal.postFragment = gql`
  fragment useSponsorPaywallModal_PostFragment on PostV2 {
    _id
    organization {
      _id
    }
  }
`;
